import { Injectable } from '@angular/core';
import { System as LegacySystem } from '@app/core/resources/system';
import { JsonapiWebsocketService } from '@app/socket/services/jsonapi-websocket.service';
import { DocumentCollection } from 'ngx-jsonapi';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SystemsRealtimePort } from 'common/systems/application/ports/systems-realtime.port';
import { System } from 'common/systems/domain/resources/system.resource';
import { mapLegacySystemToCommon } from 'ui/features/systems/infrastructure/adapters/map-legacy-system';

/**
 * Implements `SystemsRealtimePort` by wrapping the already existing
 * `JsonapiWebsocketService.onDocumentCollection<System>('systems')`
 * (fed, at the app-shell level, by the public `'systems'` channel through
 * the existing socket infrastructure, see design.md Context of
 * `systems-capability`). It does not create a new socket connection or a
 * new channel: it only subscribes to the existing output.
 */
@Injectable({ providedIn: 'root' })
export class SystemsRealtimeAdapter implements SystemsRealtimePort {
    public constructor(private readonly jsonapiWebsocketService: JsonapiWebsocketService) {}

    public onSystemsUpdated(): Observable<ReadonlyArray<System>> {
        return this.jsonapiWebsocketService
            .onDocumentCollection<LegacySystem>('systems')
            .pipe(
                map(
                    (collection: DocumentCollection<LegacySystem>): ReadonlyArray<System> =>
                        collection.data.map(
                            (legacySystem: LegacySystem): System =>
                                mapLegacySystemToCommon(legacySystem),
                        ),
                ),
            );
    }
}
